import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductComponent } from './product/product.component';
import { PdfShowComponent } from './pdf-show/pdf-show.component';
import { QcxH2b1Component } from './product/qcx-h2b1/qcx-h2b1.component';
import { QcxH2b_1Component } from './product/qcx-h2b_1/qcx-h2b_1.component';

const routes: Routes = [
  { path: ':Id', component: ProductComponent },
  { path: 'pdf/:Url', component: PdfShowComponent },
  { path: 'p/h2b1', component: QcxH2b1Component },
  { path: 'p/h2b_1', component: QcxH2b_1Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
